<div class="common-table__container-border">
  <div class="common-table-header__container">
    <div class="common-table-body__inner-row w-[calc(100%-30px)]">
      <div class="common-table-cell__container w-[25%]">
        <filter-by-search-and-order
          [item]="duplicateDocumentation.referenciaFilter"
          (launchActionFilterOrderEmit)="filterOrder($event, 'referencia')">
        </filter-by-search-and-order>
      </div>
      <div class="common-table-cell__container w-[18%]">
        <filter-by-list-and-order
          [item]="duplicateDocumentation.tipoFilter"
          [list]="duplicateDocumentation.tipoList"
          (launchActionFilterOrderEmit)="filterOrder($event, 'tipo')">
        </filter-by-list-and-order>
      </div>
      <div class="common-table-cell__container w-[25%]">
        <filter-by-search-and-order
          [item]="duplicateDocumentation.nameQueryFilter"
          (launchActionFilterOrderEmit)="filterOrder($event, 'nombreColegiado')">
        </filter-by-search-and-order>
      </div>
      <div class="common-table-cell__container w-[32%]">
        <filter-by-list-and-order
          [item]="duplicateDocumentation.materiaFilter"
          [list]="duplicateDocumentation.materiaList"
          (launchActionFilterOrderEmit)="filterOrder($event, 'materia')">
        </filter-by-list-and-order>
      </div>
    </div>
  </div>
  <div class="common-table-body__container max-h-[230px]">
    @if(duplicateDocumentation.searchingInstances){
      <div class="duplicate-documentation__spinner-empty-container">
        <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
          ariaLabel="loading"></p-progressSpinner>
      </div>
    }@else {
      @for (instance of filterConceptList | afOrderBy:duplicateDocumentation.filterOrder:duplicateDocumentation.order | afLimitTo:duplicateDocumentation.configPagination.itemsPerPage:duplicateDocumentation.configPagination.firstElement; track $index) {
        <div class="common-table-body__row"
          (click)="selectInstance(instance)">
          <div class="common-table-body__inner-row w-[calc(100%-30px)]">
            <div class="common-table-cell__container w-[25%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="instance.referencia"></span-tooltip>
            </div>
            <div class="common-table-cell__container w-[18%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="instance.tipo"></span-tooltip>
            </div>
            <div class="common-table-cell__container w-[25%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="instance.nombreColegiado"></span-tooltip>
            </div>
            <div class="common-table-cell__container w-[32%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="instance.materia"></span-tooltip>
            </div>
          </div>
          <div>
            <button class="common-button__icon-md-noborder">
              <i class="lf-icon-angle-right common-icon__md"></i>
            </button>
          </div>
        </div>
      }@empty {
        <div class="duplicate-documentation__spinner-empty-container">
          <div class="common-empty-state__message-container"
            [afTranslate]="duplicateDocumentation.createdByValue || duplicateDocumentation.titleValue?'new-evaluation.no-results':'folder.no-evaluated-concepts'">_No hay conceptos evaluados</div>
        </div>
      }
    }
  </div>
  @if(!duplicateDocumentation.searchingInstances && filterConceptList?.length){
    <div class="pagination-control">
      <div class="pagination-control__container-text-pagination">
        <span class="pagination-control__text-pagination-bold">
          <span [afTranslate]="'common.total'">_Total</span>:
          <span>{{filterConceptList.length}}</span>
        </span>
      </div>
    </div>
  }
</div>
